<template lang="pug">
.content
    setting-title(
        title="过滤规则",
        description="排除特定受访URL、来源URL、来源访客IP的访问，使分析报告中不包含此部分流量", :date="timeSpan",
    )
        div#backToReport 完成本页操作后可
            router-link(to="/web/overview") 查看分析
    .zone.content-part
        domain-select(extra="为网站$domain绑定过滤规则", @change="onDomainChange")

    timeSpan(@change="onTimespanChange")
    FilterTable(
        addText="添加排除受访URL",
        firstColText="排除的受访URL",
        placeHolder="请填写排除受访URL",
        pattern="url"
        urltype="nourl",
        :params="params",
        @listHistory="showHistoryInfo"
    )
        TableTitle(slot="icon", icon="fa fa-diamond", title="排除受访")
          .tip {{"（添加删除后实时生效）"}}
    
    FilterTable(
        addText="添加排除来源URL",
        firstColText="排除的来源URL",
        placeHolder="请填写排除来源URL",
        pattern="url"
        urltype="norefurl",
        :params="params",
        @listHistory="showHistoryInfo"
    )
        TableTitle(slot="icon", icon="fa fa-diamond", title="排除来源")
          .tip {{"（添加删除后实时生效）"}}

    FilterTable(
        addText="添加排除访客IP",
        firstColText="排除的访客IP",
        placeHolder="请填写排除访客IP",
        pattern="ip"
        urltype="noip",
        :params="params",
        @listHistory="showHistoryInfo"
    )
        TableTitle(slot="icon", icon="fa fa-diamond", title="排除访客IP列表")
          .tip {{"（添加删除后实时生效）"}}
            
    v-modal(
        :visible="historyInfoVisible",
        title="历史数据",
        @closemodal="historyInfoVisible=false",
        ref="historyModal"
    )
        .modal-bd
            .modal-content.history-content
                data-table(:url="historyApi", @getdata="setHistoryList", v-if="historyInfoVisible")
                    thead
                        tr
                            th 日期
                            th PV
                    tbody
                        tr(v-for="row in historyData")
                            td {{row.date | toDate}} 
                            td {{row.pv}}
               
</template>

<script>
import FilterTable from "./filter_table.vue";
import { getDateString }  from '../../script/util.js';
export default {
    components: { FilterTable },
    data(){
        let today = getDateString(new Date());
        return {
            list: [],
            timeSpan: { start: today, end: today},
            historyApi: '',
            historyInfoVisible: false,
            historyData: [],
            domainId: ''
        }
    },
    computed: {
        params() {
            let params =  {
                start: this.timeSpan['start'],
                end: this.timeSpan['end'],
                domainId: this.domainId
            };
            return Object.keys(params).map(k => `${k}=${params[k]}`).join('&');
        }
    },
    watch: {
        historyInfoVisible(newVal) {
            if (!newVal) {
                this.setHistoryList([]);
            }
        }
    },
    methods: {
        showHistoryInfo(urltype, row){
            let qs = this.params;
            this.historyInfoVisible = true;
            this.historyApi = `/api/${urltype}/history?${qs}&id=${row.id}`;
        },
        setHistoryList(list){
            let modalRef = this.$refs.historyModal;
            let centerFn = modalRef._centerModal;
            this.$nextTick(() => centerFn && modalRef._centerModal());
            this.historyData = list;
        },
        // 切换域名的时候
        // 包括首次进入 init 时
        onDomainChange(domain) {
            this.domainId = domain.id;
            let inputArray = document.querySelectorAll(".search")
            for( let i=0; i<inputArray.length; i++){
              inputArray[i].children[0].children[0].value = ''
            }
        },
        // 切换时间跨度的时候
        // 初始进入页面时也会触发
        onTimespanChange({ start, end }) {
            this.timeSpan = { start, end };
        },
    },
    filters: {
        toDate(dateStr) {
            let match = dateStr.match(/\d{4}-\d{2}-\d{2}/);
            return match ? match[0] : '';
        }
    }
}
</script>
<style scoped>
.content-part{ overflow: visible;}
.modal .modal-bd .modal-content {
    min-width: 700px;
}
.iframe-header{ padding-top: 0}
</style>



// WEBPACK FOOTER //
// filter.vue?0c8de80d